// import React, { useEffect, useState } from "react";
// import { Trash2, Edit } from "lucide-react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faCheckCircle,
//   faTimesCircle,
// } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";
// import Apiurl from "../environment/Apiurl";

// function User() {
//   const [responseData, setResponseData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [showEntries, setShowEntries] = useState("10");
//   const [generateUserId, setGenerateUserId] = useState("");
//   const [rolesData, setRolesData] = useState([]);
//   const [staffData, setStaffData] = useState([]);
//   const [doctorData, setDoctorData] = useState([]);
//   const [userPrivileges, setUserPrivileges] = useState({});
//   const [loadingPrivileges, setLoadingPrivileges] = useState(true);

//   const [addData, setAddData] = useState({
//     user_id: "",
//     username: "",
//     user_type: "",
//     password: "",
//     role_id: "",
//     status: "",
//   });

//   const [updateData, setUpdateData] = useState({
//     user_id: "",
//     username: "",
//     user_type: "",
//     password: "",
//     role_id: "",
//     status: "",
//   });

//   const [showAddModal, setShowAddModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [deleteId, setDeleteId] = useState(null);
//   const [editingId, setEditingId] = useState(null);

//   const fetchUserPrivileges = async () => {
//     try {
//       setLoadingPrivileges(true);
//       const userRole = localStorage.getItem("role_id") || "unknown";
//       if (userRole === "unknown") {
//         setError(
//           "No role assigned to the user. Please contact the administrator."
//         );
//         setLoadingPrivileges(false);
//         return;
//       }
//       const response = await axios.get(`${Apiurl}/roles_and_privillage`);
//       console.log("Roles data fetched:", response.data);
//       const roleData = response.data.find((role) => role.role_id === userRole);

//       if (roleData) {
//         console.log("User role data found:", roleData);
//         const privileges = {};
//         roleData.pages.forEach((page) => {
//           privileges[page.page] = {
//             ...page.priviallages,
//             access: page.access,
//           };
//         });
//         setUserPrivileges(privileges);
//       } else {
//         console.warn("User role not found:", userRole);
//         setError("No role data found for the current user.");
//       }
//     } catch (error) {
//       console.error("Error fetching user privileges:", error.message);
//       setError("Failed to fetch user privileges. Please try again.");
//     } finally {
//       setLoadingPrivileges(false);
//     }
//   };

//   const hasPermission = (permission) => {
//     if (!userPrivileges || !userPrivileges["Users"]) {
//       return false;
//     }
//     const privileges = userPrivileges["Users"];
//     if (privileges.all) return true;
//     return privileges[permission] || false;
//   };

//   const fetchRolesData = async () => {
//     try {
//       const response = await axios.get(`${Apiurl}/roles_and_privillage`);
//       console.log("Roles data fetched for dropdown:", response.data);
//       setRolesData(response.data || []);
//     } catch (error) {
//       console.error("Error fetching roles:", error.message);
//       setError("Failed to fetch roles. Please try again.");
//     }
//   };

//   const fetchStaffData = async () => {
//     try {
//       const response = await axios.get(`${Apiurl}/staff`);
//       console.log("Staff data fetched:", response.data);
//       setStaffData(response.data || []);
//     } catch (error) {
//       console.error("Error fetching staff:", error.message);
//       setError("Failed to fetch staff data. Please try again.");
//     }
//   };

//   const fetchDoctorData = async () => {
//     try {
//       const response = await axios.get(`${Apiurl}/doctor`);
//       console.log("Doctor data fetched:", response.data);
//       setDoctorData(response.data || []);
//     } catch (error) {
//       console.error("Error fetching doctors:", error.message);
//       setError("Failed to fetch doctor data. Please try again.");
//     }
//   };

//   const fetchGenerate = async () => {
//     try {
//       const response = await axios.get(`${Apiurl}/generate_user_id`);
//       const userId = response.data.user_id;
//       console.log("Generated user ID:", userId);
//       setGenerateUserId(userId);
//       // setAddData((prev) => ({ ...prev, user_id: userId }));
//     } catch (error) {
//       console.error("Error fetching generated user ID:", error.message);
//       setError("Failed to generate user ID. Please try again.");
//     }
//   };

//   const fetchData = async () => {
//     if (!hasPermission("read")) {
//       console.warn("No read permission for users");
//       setError("You do not have permission to view users.");
//       return;
//     }
//     setLoading(true);
//     try {
//       const response = await axios.get(`${Apiurl}/user`);
//       console.log("Users data fetched:", response.data);
//       setResponseData(response.data || []);
//       setError(null);
//     } catch (error) {
//       console.error("Error fetching users:", error.message);
//       setError("Failed to fetch users. Please try again.");
//       setResponseData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     console.log("Fetching initial data...");
//     fetchUserPrivileges();
//   }, []);

//   useEffect(() => {
//     if (hasPermission("read")) {
//       console.log("Fetching users data due to read permission...");
//       fetchData();
//     }
//     if (hasPermission("create")) {
//       console.log(
//         "Fetching roles, staff, and doctor data due to create permission..."
//       );
//       fetchRolesData();
//       fetchStaffData();
//       fetchDoctorData();
//       fetchGenerate();
//     }
//   }, [userPrivileges]);

//   const handleAddInputChange = (e) => {
//     const { name, value } = e.target;
//     console.log(`Add form input changed - ${name}: ${value}`);
//     setAddData((prev) => {
//       const newData = { ...prev, [name]: value };
//       if (name === "user_type") {
//         newData.username = "";
//       }
//       return newData;
//     });
//   };

//   const handleEditInputChange = (e) => {
//     const { name, value } = e.target;
//     console.log(`Edit form input changed - ${name}: ${value}`);
//     setUpdateData((prev) => {
//       const newData = { ...prev, [name]: value };
//       if (name === "user_type") {
//         newData.username = "";
//       }
//       return newData;
//     });
//   };

//   const validateForm = (data) => {
//     if (!data.user_type) return "User Type is required.";
//     if (!data.username) return "Username is required.";
//     if (!data.password || data.password.length < 6)
//       return "Password must be at least 6 characters.";
//     if (!data.role_id) return "Role is required.";
//     if (!data.status) return "Status is required.";
//     return null;
//   };

//   const update_validateForm = (data) => {
//     if (!data.user_type) return "User Type is required.";
//     if (!data.username) return "Username is required.";
//     // if (!data.password || data.password.length < 6)
//     //   return "Password must be at least 6 characters.";

//     if (data.password && data.password.length < 6)
//       return "Password must be at least 6 characters.";

//     if (!data.role_id) return "Role is required.";
//     if (!data.status) return "Status is required.";
//     return null;
//   };

//   const handleAddSubmit = async (e) => {
//     // e.preventDefault();
//     // console.log("the addData in the handleAddSubmit is:",addData);
//     // return;

//     e.preventDefault();
//     setError(null);
//     if (!hasPermission("create")) {
//       setError("You do not have permission to add users.");
//       return;
//     }
//     const validationError = validateForm(addData);
//     if (validationError) {
//       setError(validationError);
//       return;
//     }
//     try {
//       // const formData = { ...addData, user_id: generateUserId };
//       const formData = { ...addData };
//       console.log("Adding user with data:", formData);
//       await axios.post(`${Apiurl}/user`, formData);
//       setAddData({
//         // user_id: generateUserId,
//         user_id: "",
//         username: "",
//         user_type: "",
//         password: "",
//         role_id: "",
//         status: "",
//       });
//       fetchData();
//       fetchGenerate();
//       closeAddModal();
//     } catch (error) {
//       console.error("Error adding user:", error.message);
//       // setError("Failed to add user. Please try again.");

//       if (error.response.status === 409) {
//         setError("The user id already exist. Please try again.");
//       } else {
//         setError("Failed to add user. Please try again.");
//       }
//       setTimeout(() => setError(null), 3000);
//     }
//   };

//   const handleEditSubmit = async (e) => {
//     e.preventDefault();
//     if (!hasPermission("update")) {
//       setError("You do not have permission to edit users.");
//       return;
//     }

//     // const validationError = validateForm(updateData);
//     const validationError = update_validateForm(updateData);

//     if (validationError) {
//       setError(validationError);
//       return;
//     }
//     try {
//       console.log("Updating user with ID:", editingId, "Data:", updateData);
//       await axios.put(`${Apiurl}/user/${editingId}`, updateData);
//       fetchData();
//       closeEditModal();
//     } catch (error) {
//       console.error("Error updating user:", error.message);
//       setError("Failed to update user. Please try again.");
//       setTimeout(() => setError(null), 3000);
//     }
//   };

//   const confirmDelete = async () => {
//     if (!hasPermission("delete")) {
//       setError("You do not have permission to delete users.");
//       return;
//     }
//     try {
//       console.log("Deleting user with ID:", deleteId);
//       await axios.delete(`${Apiurl}/user/${deleteId}`);
//       fetchData();
//       closeDeleteModal();
//     } catch (error) {
//       console.error("Error deleting user:", error.message);
//       setError("Failed to delete user. Please try again.");
//       setTimeout(() => setError(null), 3000);
//     }
//   };

//   const openAddModal = () => {
//     if (hasPermission("create")) {
//       console.log("Opening Add User modal");
//       setShowAddModal(true);
//     }
//   };

//   const closeAddModal = () => {
//     console.log("Closing Add User modal");
//     setShowAddModal(false);
//     setAddData({
//       // user_id: generateUserId,
//       user_id: "",
//       username: "",
//       user_type: "",
//       password: "",
//       role_id: "",
//       status: "",
//     });
//     setError(null);
//   };

//   const closeEditModal = () => {
//     console.log("Closing Edit User modal");
//     setShowEditModal(false);
//     setEditingId(null);
//     setUpdateData({
//       user_id: "",
//       username: "",
//       user_type: "",
//       password: "",
//       role_id: "",
//       status: "",
//     });
//     setError(null);
//   };

//   const openDeleteModal = (id) => {
//     if (hasPermission("delete")) {
//       console.log("Opening Delete User modal for ID:", id);
//       setDeleteId(id);
//       setShowDeleteModal(true);
//     }
//   };

//   const closeDeleteModal = () => {
//     console.log("Closing Delete User modal");
//     setShowDeleteModal(false);
//     setDeleteId(null);
//     setError(null);
//   };

//   const handleEdit = (id, user) => {
//     if (hasPermission("update")) {
//       console.log("Opening Edit User modal for ID:", id, "User:", user);
//       setEditingId(id);
//       setUpdateData({
//         user_id: user.user_id || "",
//         username: user.username || "",
//         user_type: user.user_type || "",
//         // password: user.password || "",
//         password: "",
//         role_id: user.role_id || "",
//         status: user.status || "",
//       });
//       setShowEditModal(true);
//     }
//   };

//   const filteredData = responseData.filter((user) => {
//     const displayName =
//       user.user_type === "Doctor"
//         ? doctorData.find((doc) => doc.doctor_id === user.username)
//             ?.doctor_name || user.username
//         : staffData.find((staff) => staff.staff_id === user.username)
//             ?.first_name || user.username;

//     return (
//       displayName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       user.user_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       user.user_type?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       user.role_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       user.status?.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//   });

//   useEffect(() => {
//     console.log("Updating items per page to:", showEntries);
//     if (showEntries === "All") {
//       setItemsPerPage(filteredData.length || 1);
//     } else {
//       setItemsPerPage(Number(showEntries));
//     }
//   }, [showEntries, filteredData]);

//   useEffect(() => {
//     console.log(
//       "Resetting current page due to searchTerm or itemsPerPage change"
//     );
//     setCurrentPage(1);
//   }, [searchTerm, itemsPerPage]);

//   const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

//   const getPageList = () => {
//     const pages = [];
//     if (totalPages <= 7) {
//       for (let i = 1; i <= totalPages; i++) pages.push(i);
//     } else {
//       if (currentPage <= 4) {
//         pages.push(1, 2, 3, 4, 5, "...", totalPages);
//       } else if (currentPage >= totalPages - 3) {
//         pages.push(
//           1,
//           "...",
//           totalPages - 4,
//           totalPages - 3,
//           totalPages - 2,
//           totalPages - 1,
//           totalPages
//         );
//       } else {
//         pages.push(
//           1,
//           "...",
//           currentPage - 1,
//           currentPage,
//           currentPage + 1,
//           "...",
//           totalPages
//         );
//       }
//     }
//     return pages;
//   };

//   const handlePageClick = (page) => {
//     if (page !== "..." && page !== currentPage) {
//       console.log("Navigating to page:", page);
//       setCurrentPage(page);
//     }
//   };

//   const pages = getPageList();

//   if (loadingPrivileges) {
//     return <div className="p-3">Loading permissions...</div>;
//   }

//   if (!hasPermission("access")) {
//     console.log(
//       "Access denied for role_id:",
//       localStorage.getItem("role_id"),
//       "on Users page"
//     );
//     return (
//       <div className="p-3">
//         <div className="alert alert-danger">
//           You don't have permission to access this page.
//         </div>
//       </div>
//     );
//   }

//   const getUsernameOptions = (userType) => {
//     const data = userType === "Doctor" ? doctorData : staffData;

//     return [
//       <option key="select" value="">
//         Select User
//       </option>,
//       ...data.map((item) => {
//         const id = item.staff_id || item.doctor_id;
//         const name =
//           userType === "Doctor"
//             ? item.doctor_name
//             : `${item.first_name} ${item.last_name}`;
//         return (
//           <option key={id} value={id}>
//             {id} - {name}
//           </option>
//         );
//       }),
//     ];
//   };

//   return (
//     <div className="p-3">
//       {hasPermission("create") && (
//         <div className="text-end">
//           <button
//             className="btn btn-sm text-white"
//             style={{ backgroundColor: "#01AEBE" }}
//             onClick={openAddModal}
//           >
//             + Add User
//           </button>
//         </div>
//       )}

//       {error && (
//         <div className="alert alert-danger alert-dismissible fade show mt-2">
//           {error}
//           <button
//             type="button"
//             className="btn-close"
//             onClick={() => setError(null)}
//           ></button>
//         </div>
//       )}

//       {hasPermission("read") && (
//         <div className="card card-body mt-2">
//           <div className="bg-white rounded shadow-sm">
//             <div className="row mb-3">
//               <div className="col-md-2">
//                 <div className="input-group">
//                   <span className="input-group-text">
//                     <i className="fas fa-table"></i>
//                   </span>
//                   <select
//                     className="form-select"
//                     value={showEntries}
//                     onChange={(e) => {
//                       console.log(
//                         "Changing items per page to:",
//                         e.target.value
//                       );
//                       setShowEntries(e.target.value);
//                       setItemsPerPage(
//                         e.target.value === "All"
//                           ? filteredData.length || 1
//                           : parseInt(e.target.value)
//                       );
//                       setCurrentPage(1);
//                     }}
//                   >
//                     <option value="10">Show 10</option>
//                     <option value="20">Show 20</option>
//                     <option value="50">Show 50</option>
//                     <option value="100">Show 100</option>
//                     <option value="All">Show All</option>
//                   </select>
//                 </div>
//               </div>
//               <div className="col-md-7"></div>
//               <div className="col-md-3">
//                 <div className="d-flex align-items-center">
//                   <div className="position-relative">
//                     <input
//                       type="text"
//                       className="form-control pe-5"
//                       placeholder="Search"
//                       value={searchTerm}
//                       onChange={(e) => {
//                         console.log("Search term changed to:", e.target.value);
//                         setSearchTerm(e.target.value);
//                       }}
//                       style={{ width: "250px", paddingRight: "2.5rem" }}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {loading && <div className="text-center py-3">Loading...</div>}

//             <div className="table-responsive">
//               <table className="table table-hover">
//                 <thead style={{ backgroundColor: "#01AEBE", color: "white" }}>
//                   <tr>
//                     <th>S.No</th>
//                     <th>User ID</th>
//                     <th>Username</th>
//                     <th>User Type</th>
//                     <th>Role</th>
//                     <th>Status</th>
//                     {(hasPermission("update") || hasPermission("delete")) && (
//                       <th>Action</th>
//                     )}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {currentItems.length > 0 ? (
//                     currentItems.map((user, index) => (
//                       <tr key={user._id || index} className="align-middle">
//                         <td>{indexOfFirstItem + index + 1}</td>
//                         <td>{user.user_id}</td>
//                         <td>
//                           {user.user_type === "Doctor"
//                             ? doctorData.find(
//                                 (doc) => doc.doctor_id === user.username
//                               )?.doctor_name || user.username
//                             : staffData.find(
//                                 (staff) => staff.staff_id === user.username
//                               )?.first_name || user.username}
//                         </td>
//                         <td>{user.user_type}</td>
//                         <td>{user.roles_details[0]?.role_name}</td>
//                         <td>
//                           <span
//                             className={`badge rounded-pill px-3 py-2 fw-semibold d-inline-flex align-items-center ${
//                               user.status?.toLowerCase() === "active"
//                                 ? "bg-success text-white"
//                                 : "bg-danger text-white"
//                             }`}
//                           >
//                             <FontAwesomeIcon
//                               icon={
//                                 user.status?.toLowerCase() === "active"
//                                   ? faCheckCircle
//                                   : faTimesCircle
//                               }
//                               className="me-2"
//                             />
//                             {user.status?.toLowerCase() === "active"
//                               ? "Active"
//                               : "Inactive"}
//                           </span>
//                         </td>

//                         {(hasPermission("update") ||
//                           hasPermission("delete")) && (
//                           <td>
//                             {user.user_id !== "AFC-U-001" && (
//                               <>
//                                 {hasPermission("delete") && (
//                                   <button
//                                     className="btn btn-sm p-1 border-0"
//                                     style={{ backgroundColor: "transparent" }}
//                                     onClick={() => openDeleteModal(user._id)}
//                                   >
//                                     <Trash2 size={16} className="text-danger" />
//                                   </button>
//                                 )}
//                                 {hasPermission("update") && (
//                                   <button
//                                     className="btn btn-sm p-1 border-0"
//                                     style={{ backgroundColor: "transparent" }}
//                                     onClick={() => handleEdit(user._id, user)}
//                                   >
//                                     <Edit size={16} className="text-primary" />
//                                   </button>
//                                 )}
//                               </>
//                             )}
//                             {user.user_id === "AFC-U-001" &&
//                               hasPermission("update") && (
//                                 <button
//                                   className="btn btn-sm p-1 border-0"
//                                   style={{ backgroundColor: "transparent" }}
//                                   onClick={() => handleEdit(user._id, user)}
//                                 >
//                                   <Edit size={16} className="text-primary" />
//                                 </button>
//                               )}
//                           </td>
//                         )}
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td
//                         colSpan={
//                           hasPermission("update") || hasPermission("delete")
//                             ? 7
//                             : 6
//                         }
//                         className="text-center py-3"
//                       >
//                         {loading ? "Loading..." : "No users found"}
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             <div className="container">
//               <div className="d-flex justify-content-between align-items-center p-3 border-top gap-2">
//                 <button
//                   className="btn btn-outline-secondary d-flex align-items-center gap-2"
//                   onClick={() =>
//                     currentPage > 1 && setCurrentPage(currentPage - 1)
//                   }
//                   disabled={currentPage === 1}
//                 >
//                   <i className="fas fa-chevron-left"></i>
//                   <span className="d-none d-sm-inline">Previous</span>
//                 </button>

//                 <div
//                   className="d-flex overflow-auto flex-nowrap gap-2 px-2"
//                   style={{ maxWidth: "100%" }}
//                 >
//                   {pages.map((page, index) => (
//                     <button
//                       key={index}
//                       className={`btn btn-sm px-3 flex-shrink-0 ${
//                         page === currentPage
//                           ? "text-white"
//                           : "btn-outline-secondary"
//                       }`}
//                       style={
//                         page === currentPage
//                           ? { backgroundColor: "#20c997", border: "none" }
//                           : {}
//                       }
//                       onClick={() => handlePageClick(page)}
//                       disabled={page === "..."}
//                     >
//                       {page}
//                     </button>
//                   ))}
//                 </div>

//                 <button
//                   className="btn btn-outline-secondary d-flex align-items-center gap-2"
//                   onClick={() =>
//                     currentPage < totalPages && setCurrentPage(currentPage + 1)
//                   }
//                   disabled={currentPage === totalPages}
//                 >
//                   <span className="d-none d-sm-inline">Next</span>
//                   <i className="fas fa-chevron-right"></i>
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {hasPermission("create") && (
//         <div
//           className={`modal fade ${showAddModal ? "show" : ""}`}
//           style={{ display: showAddModal ? "block" : "none" }}
//           tabIndex="-1"
//           aria-labelledby="addUserModalLabel"
//           aria-hidden={!showAddModal}
//         >
//           <div className="modal-dialog modal-md modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h6 className="modal-title text-dark" id="addUserModalLabel">
//                   Add User
//                 </h6>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   style={{ fontSize: "10px" }}
//                   onClick={closeAddModal}
//                   aria-label="Close"
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <form onSubmit={handleAddSubmit}>
//                   <div className="row mb-1">
//                     <div className="col-md-6">
//                       <label htmlFor="user_id" className="form-label fw-bold">
//                         User ID
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="user_id"
//                         name="user_id"
//                         value={addData.user_id}
//                         onChange={handleAddInputChange}
//                         // value={generateUserId}
//                         // readOnly
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="user_type" className="form-label fw-bold">
//                         User Type
//                       </label>
//                       <select
//                         className="form-select"
//                         id="user_type"
//                         name="user_type"
//                         value={addData.user_type}
//                         onChange={handleAddInputChange}
//                         required
//                       >
//                         <option value="">Select User Type</option>
//                         <option value="Management">Management</option>
//                         <option value="Doctor">Doctor</option>
//                         <option value="Staff">Staff</option>
//                       </select>
//                     </div>
//                   </div>
//                   <div className="row mb-1">
//                     <div className="col-md-6">
//                       <label htmlFor="username" className="form-label fw-bold">
//                         Username
//                       </label>
//                       <select
//                         className="form-select"
//                         id="username"
//                         name="username"
//                         value={addData.username}
//                         onChange={handleAddInputChange}
//                         required
//                         disabled={!addData.user_type}
//                       >
//                         {getUsernameOptions(addData.user_type)}
//                       </select>
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="password" className="form-label fw-bold">
//                         Password
//                       </label>
//                       <input
//                         type="password"
//                         className="form-control"
//                         id="password"
//                         name="password"
//                         placeholder="Enter Password"
//                         value={addData.password}
//                         onChange={handleAddInputChange}
//                         required
//                       />
//                     </div>
//                   </div>
//                   <div className="row mb-1">
//                     <div className="col-md-6">
//                       <label htmlFor="role_id" className="form-label fw-bold">
//                         Role
//                       </label>
//                       <select
//                         className="form-select"
//                         id="role_id"
//                         name="role_id"
//                         value={addData.role_id}
//                         onChange={handleAddInputChange}
//                         required
//                       >
//                         <option value="">Select Role</option>
//                         {rolesData.map((item) => (
//                           <option key={item.id} value={item.role_id}>
//                             {item.role_id} - {item.role_name}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="status" className="form-label fw-bold">
//                         Status
//                       </label>
//                       <select
//                         className="form-select"
//                         id="status"
//                         name="status"
//                         value={addData.status}
//                         onChange={handleAddInputChange}
//                         required
//                       >
//                         <option value="">Select Status</option>
//                         <option value="active">Active</option>
//                         <option value="inactive">Inactive</option>
//                       </select>
//                     </div>
//                   </div>
//                   <div className="text-center mt-4">
//                     <button
//                       type="button"
//                       className="btn btn-sm px-3 me-2"
//                       style={{ backgroundColor: "#e0e0e0", color: "#333" }}
//                       onClick={closeAddModal}
//                     >
//                       Cancel
//                     </button>
//                     <button
//                       type="submit"
//                       className="btn text-white btn-sm px-4"
//                       style={{ backgroundColor: "#01AEBE" }}
//                     >
//                       Submit
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {hasPermission("update") && (
//         <div
//           className={`modal fade ${showEditModal ? "show" : ""}`}
//           style={{ display: showEditModal ? "block" : "none" }}
//           tabIndex="-1"
//           aria-labelledby="editUserModalLabel"
//           aria-hidden={!showEditModal}
//         >
//           <div className="modal-dialog modal-md modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h6 className="modal-title text-dark" id="editUserModalLabel">
//                   Edit User
//                 </h6>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   style={{ fontSize: "10px" }}
//                   onClick={closeEditModal}
//                   aria-label="Close"
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <form onSubmit={handleEditSubmit}>
//                   <div className="row mb-1">
//                     <div className="col-md-6">
//                       <label htmlFor="user_id" className="form-label fw-bold">
//                         User ID
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="user_id"
//                         name="user_id"
//                         value={updateData.user_id}
//                         readOnly
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="user_type" className="form-label fw-bold">
//                         User Type
//                       </label>
//                       <select
//                         className="form-select"
//                         id="user_type"
//                         name="user_type"
//                         value={updateData.user_type}
//                         onChange={handleEditInputChange}
//                         required
//                       >
//                         <option value="">Select User Type</option>
//                         <option value="Management">Management</option>
//                         <option value="Doctor">Doctor</option>
//                         <option value="Staff">Staff</option>
//                       </select>
//                     </div>
//                   </div>
//                   <div className="row mb-1">
//                     <div className="col-md-6">
//                       <label htmlFor="username" className="form-label fw-bold">
//                         Username
//                       </label>
//                       <select
//                         className="form-select"
//                         id="username"
//                         name="username"
//                         value={updateData.username}
//                         onChange={handleEditInputChange}
//                         required
//                         disabled={!updateData.user_type}
//                       >
//                         {getUsernameOptions(updateData.user_type)}
//                       </select>
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="password" className="form-label fw-bold">
//                         Password
//                       </label>
//                       <input
//                         type="password"
//                         className="form-control"
//                         id="password"
//                         name="password"
//                         placeholder="Enter Password"
//                         value={updateData.password}
//                         onChange={handleEditInputChange}
//                         // required
//                       />
//                     </div>
//                   </div>
//                   <div className="row mb-1">
//                     <div className="col-md-6">
//                       <label htmlFor="role_id" className="form-label fw-bold">
//                         Role
//                       </label>
//                       <select
//                         className="form-select"
//                         id="role_id"
//                         name="role_id"
//                         value={updateData.role_id}
//                         onChange={handleEditInputChange}
//                         required
//                       >
//                         <option value="">Select Role</option>
//                         {rolesData.map((item) => (
//                           <option key={item.id} value={item.role_id}>
//                             {item.role_id} - {item.role_name}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="status" className="form-label fw-bold">
//                         Status
//                       </label>
//                       <select
//                         className="form-select"
//                         id="status"
//                         name="status"
//                         value={updateData.status}
//                         onChange={handleEditInputChange}
//                         required
//                       >
//                         <option value="">Select Status</option>
//                         <option value="active">Active</option>
//                         <option value="inactive">Inactive</option>
//                       </select>
//                     </div>
//                   </div>
//                   <div className="text-center mt-4">
//                     <button
//                       type="button"
//                       className="btn btn-sm px-3 me-2"
//                       style={{ backgroundColor: "#e0e0e0", color: "#333" }}
//                       onClick={closeEditModal}
//                     >
//                       Cancel
//                     </button>
//                     <button
//                       type="submit"
//                       className="btn text-white btn-sm px-4"
//                       style={{ backgroundColor: "#01AEBE" }}
//                     >
//                       Update
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {hasPermission("delete") && (
//         <div
//           className={`modal fade ${showDeleteModal ? "show" : ""}`}
//           style={{ display: showDeleteModal ? "block" : "none" }}
//           tabIndex="-1"
//           aria-labelledby="deleteUserModalLabel"
//           aria-hidden={!showDeleteModal}
//         >
//           <div className="modal-dialog modal-sm modal-dialog-centered">
//             <div className="modal-content" style={{ borderRadius: "10px" }}>
//               <div className="modal-header" style={{ borderBottom: "none" }}>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   style={{ fontSize: "10px" }}
//                   onClick={closeDeleteModal}
//                   aria-label="Close"
//                 ></button>
//               </div>
//               <div className="modal-body text-center">
//                 <div style={{ marginBottom: "15px" }}>
//                   <span
//                     style={{
//                       display: "inline-block",
//                       width: "40px",
//                       height: "40px",
//                       backgroundColor: "#fee2e2",
//                       borderRadius: "50%",
//                       textAlign: "center",
//                       lineHeight: "40px",
//                     }}
//                   >
//                     <i
//                       className="fas fa-exclamation-triangle"
//                       style={{ color: "#dc2626", fontSize: "20px" }}
//                     ></i>
//                   </span>
//                 </div>
//                 <h5 className="modal-title" id="deleteUserModalLabel">
//                   Delete User
//                 </h5>
//                 <p style={{ marginTop: "10px" }}>
//                   You're going to delete this user. Are you sure?
//                 </p>
//               </div>
//               <div
//                 className="modal-footer"
//                 style={{ borderTop: "none", justifyContent: "center" }}
//               >
//                 <button
//                   type="button"
//                   className="btn btn-secondary btn-sm"
//                   style={{
//                     marginRight: "10px",
//                     backgroundColor: "#e0e0e0",
//                     color: "#333",
//                   }}
//                   onClick={closeDeleteModal}
//                 >
//                   No, Keep it
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-danger btn-sm"
//                   onClick={confirmDelete}
//                 >
//                   Yes, Delete It!
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {(showAddModal || showEditModal || showDeleteModal) && (
//         <div className="modal-backdrop fade show"></div>
//       )}
//     </div>
//   );
// }

// export default User;


import React, { useEffect, useState } from "react";
import { Trash2, Edit } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import Apiurl from "../environment/Apiurl";

function User() {
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showEntries, setShowEntries] = useState("10");
  const [generateUserId, setGenerateUserId] = useState("");
  const [rolesData, setRolesData] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [doctorData, setDoctorData] = useState([]);
  const [userPrivileges, setUserPrivileges] = useState({});
  const [loadingPrivileges, setLoadingPrivileges] = useState(true);
   const [isSubmitting, setIsSubmitting] = useState(false);

  const [addData, setAddData] = useState({
    user_id: "",
    username: "",
    user_type: "",
    password: "",
    role_id: "",
    status: "",
  });

  const [updateData, setUpdateData] = useState({
    user_id: "",
    username: "",
    user_type: "",
    password: "",
    role_id: "",
    status: "",
  });

  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [editingId, setEditingId] = useState(null);

  const fetchUserPrivileges = async () => {
    try {
      setLoadingPrivileges(true);
      const userRole = localStorage.getItem("role_id") || "unknown";
      if (userRole === "unknown") {
        setError(
          "No role assigned to the user. Please contact the administrator."
        );
        setLoadingPrivileges(false);
        return;
      }
      const response = await axios.get(`${Apiurl}/roles_and_privillage`);
      console.log("Roles data fetched:", response.data);
      const roleData = response.data.find((role) => role.role_id === userRole);

      if (roleData) {
        console.log("User role data found:", roleData);
        const privileges = {};
        roleData.pages.forEach((page) => {
          privileges[page.page] = {
            ...page.priviallages,
            access: page.access,
          };
        });
        setUserPrivileges(privileges);
      } else {
        console.warn("User role not found:", userRole);
        setError("No role data found for the current user.");
      }
    } catch (error) {
      console.error("Error fetching user privileges:", error.message);
      setError("Failed to fetch user privileges. Please try again.");
    } finally {
      setLoadingPrivileges(false);
    }
  };

  const hasPermission = (permission) => {
    if (!userPrivileges || !userPrivileges["Users"]) {
      return false;
    }
    const privileges = userPrivileges["Users"];
    if (privileges.all) return true;
    return privileges[permission] || false;
  };

  const fetchRolesData = async () => {
    try {
      const response = await axios.get(`${Apiurl}/roles_and_privillage`);
      console.log("Roles data fetched for dropdown:", response.data);
      setRolesData(response.data || []);
    } catch (error) {
      console.error("Error fetching roles:", error.message);
      setError("Failed to fetch roles. Please try again.");
    }
  };

  const fetchStaffData = async () => {
    try {
      const response = await axios.get(`${Apiurl}/staff`);
      console.log("Staff data fetched:", response.data);
      setStaffData(response.data || []);
    } catch (error) {
      console.error("Error fetching staff:", error.message);
      setError("Failed to fetch staff data. Please try again.");
    }
  };

  const fetchDoctorData = async () => {
    try {
      const response = await axios.get(`${Apiurl}/doctor`);
      console.log("Doctor data fetched:", response.data);
      setDoctorData(response.data || []);
    } catch (error) {
      console.error("Error fetching doctors:", error.message);
      setError("Failed to fetch doctor data. Please try again.");
    }
  };

  const fetchGenerate = async () => {
    try {
      const response = await axios.get(`${Apiurl}/generate_user_id`);
      const userId = response.data.user_id;
      console.log("Generated user ID:", userId);
      setGenerateUserId(userId);
      // setAddData((prev) => ({ ...prev, user_id: userId }));
    } catch (error) {
      console.error("Error fetching generated user ID:", error.message);
      setError("Failed to generate user ID. Please try again.");
    }
  };

  const fetchData = async () => {
    if (!hasPermission("read")) {
      console.warn("No read permission for users");
      setError("You do not have permission to view users.");
      return;
    }
    setLoading(true);
    try {
      const response = await axios.get(`${Apiurl}/user`);
      console.log("Users data fetched:", response.data);
      setResponseData(response.data || []);
      setError(null);
    } catch (error) {
      console.error("Error fetching users:", error.message);
      setError("Failed to fetch users. Please try again.");
      setResponseData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("Fetching initial data...");
    fetchUserPrivileges();
  }, []);

  useEffect(() => {
    if (hasPermission("read")) {
      console.log("Fetching users data due to read permission...");
      fetchData();
    }
    if (hasPermission("create")) {
      console.log(
        "Fetching roles, staff, and doctor data due to create permission..."
      );
      fetchRolesData();
      fetchStaffData();
      fetchDoctorData();
      fetchGenerate();
    }
  }, [userPrivileges]);

  const handleAddInputChange = (e) => {
    const { name, value } = e.target;
    console.log(`Add form input changed - ${name}: ${value}`);
    setAddData((prev) => {
      const newData = { ...prev, [name]: value };
      if (name === "user_type") {
        newData.username = "";
      }
      return newData;
    });
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    console.log(`Edit form input changed - ${name}: ${value}`);
    setUpdateData((prev) => {
      const newData = { ...prev, [name]: value };
      if (name === "user_type") {
        newData.username = "";
      }
      return newData;
    });
  };

  const validateForm = (data) => {
    if (!data.user_type) return "User Type is required.";
    if (!data.username) return "Username is required.";
    if (!data.password || data.password.length < 6)
      return "Password must be at least 6 characters.";
    if (!data.role_id) return "Role is required.";
    if (!data.status) return "Status is required.";
    return null;
  };

  const update_validateForm = (data) => {
    if (!data.user_type) return "User Type is required.";
    if (!data.username) return "Username is required.";
    // if (!data.password || data.password.length < 6)
    //   return "Password must be at least 6 characters.";

    if (data.password && data.password.length < 6)
      return "Password must be at least 6 characters.";

    if (!data.role_id) return "Role is required.";
    if (!data.status) return "Status is required.";
    return null;
  };


 const handleAddSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return; 
    setIsSubmitting(true);

    setError(null);

    if (!hasPermission("create")) {
      setError("You do not have permission to add users.");
      setIsSubmitting(false);
      return;
    }

    const validationError = validateForm(addData);
    if (validationError) {
      setError(validationError);
      setIsSubmitting(false);
      return;
    }

    try {
      const formData = { ...addData };
      console.log("Adding user with data:", formData);
      await axios.post(`${Apiurl}/user`, formData);

      // Reset the form
      setAddData({
        user_id: "",
        username: "",
        user_type: "",
        password: "",
        role_id: "",
        status: "",
      });

      fetchData();
      fetchGenerate();
      closeAddModal();
    } catch (error) {
      console.error("Error adding user:", error.message);
      if (error.response && error.response.status === 409) {
        setError("The user id already exists. Please try again.");
      } else {
        setError("Failed to add user. Please try again.");
      }
      setTimeout(() => setError(null), 3000);
    } finally {
      setIsSubmitting(false); // 🧩 Allow next submission after completion
    }
  };


    // const handleAddSubmit = async (e) => {
  //   e.preventDefault();
  //   setError(null);
  //   if (!hasPermission("create")) {
  //     setError("You do not have permission to add users.");
  //     return;
  //   }
  //   const validationError = validateForm(addData);
  //   if (validationError) {
  //     setError(validationError);
  //     return;
  //   }
  //   try {
  //     const formData = { ...addData };
  //     console.log("Adding user with data:", formData);
  //     await axios.post(`${Apiurl}/user`, formData);
  //     setAddData({
  //       user_id: "",
  //       username: "",
  //       user_type: "",
  //       password: "",
  //       role_id: "",
  //       status: "",
  //     });
  //     fetchData();
  //     fetchGenerate();
  //     closeAddModal();
  //   } catch (error) {
  //     console.error("Error adding user:", error.message);

  //     if (error.response && error.response.status === 409) {
  //       setError("The user id already exist. Please try again.");
  //     } else {
  //       setError("Failed to add user. Please try again.");
  //     }
  //     setTimeout(() => setError(null), 3000);
  //   }
  // };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!hasPermission("update")) {
      setError("You do not have permission to edit users.");
      return;
    }

    const validationError = update_validateForm(updateData);

    if (validationError) {
      setError(validationError);
      return;
    }
    try {
      console.log("Updating user with ID:", editingId, "Data:", updateData);
      await axios.put(`${Apiurl}/user/${editingId}`, updateData);
      fetchData();
      closeEditModal();
    } catch (error) {
      console.error("Error updating user:", error.message);
      setError("Failed to update user. Please try again.");
      setTimeout(() => setError(null), 3000);
    }
  };

  const confirmDelete = async () => {
    if (!hasPermission("delete")) {
      setError("You do not have permission to delete users.");
      return;
    }
    try {
      console.log("Deleting user with ID:", deleteId);
      await axios.delete(`${Apiurl}/user/${deleteId}`);
      fetchData();
      closeDeleteModal();
    } catch (error) {
      console.error("Error deleting user:", error.message);
      setError("Failed to delete user. Please try again.");
      setTimeout(() => setError(null), 3000);
    }
  };

  const openAddModal = () => {
    if (hasPermission("create")) {
      console.log("Opening Add User modal");
      setShowAddModal(true);
    }
  };

  const closeAddModal = () => {
    console.log("Closing Add User modal");
    setShowAddModal(false);
    setAddData({
      user_id: "",
      username: "",
      user_type: "",
      password: "",
      role_id: "",
      status: "",
    });
    setError(null);
  };

  const closeEditModal = () => {
    console.log("Closing Edit User modal");
    setShowEditModal(false);
    setEditingId(null);
    setUpdateData({
      user_id: "",
      username: "",
      user_type: "",
      password: "",
      role_id: "",
      status: "",
    });
    setError(null);
  };

  const openDeleteModal = (id) => {
    if (hasPermission("delete")) {
      console.log("Opening Delete User modal for ID:", id);
      setDeleteId(id);
      setShowDeleteModal(true);
    }
  };

  const closeDeleteModal = () => {
    console.log("Closing Delete User modal");
    setShowDeleteModal(false);
    setDeleteId(null);
    setError(null);
  };

  const handleEdit = (id, user) => {
    if (hasPermission("update")) {
      console.log("Opening Edit User modal for ID:", id, "User:", user);
      setEditingId(id);
      setUpdateData({
        user_id: user.user_id || "",
        username: user.username || "",
        user_type: user.user_type || "",
        password: "",
        role_id: user.role_id || "",
        status: user.status || "",
      });
      setShowEditModal(true);
    }
  };

  const filteredData = responseData.filter((user) => {
    const displayName =
      user.user_type === "Doctor"
        ? doctorData.find((doc) => doc.doctor_id === user.username)
          ?.doctor_name || user.username
        : user.user_type === "Staff"
          ? staffData.find((staff) => staff.staff_id === user.username)
            ?.first_name || user.username
          : user.username; // For Management users, display username as is

    return (
      displayName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.user_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.user_type?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.role_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.roles_details[0]?.role_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.status?.toLowerCase().includes(searchTerm.toLowerCase()) 
    );
  });

  useEffect(() => {
    console.log("Updating items per page to:", showEntries);
    if (showEntries === "All") {
      setItemsPerPage(filteredData.length || 1);
    } else {
      setItemsPerPage(Number(showEntries));
    }
  }, [showEntries, filteredData]);

  useEffect(() => {
    console.log(
      "Resetting current page due to searchTerm or itemsPerPage change"
    );
    setCurrentPage(1);
  }, [searchTerm, itemsPerPage]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const getPageList = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 4) {
        pages.push(1, 2, 3, 4, 5, "...", totalPages);
      } else if (currentPage >= totalPages - 3) {
        pages.push(
          1,
          "...",
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }
    return pages;
  };

    useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handlePageClick = (page) => {
    if (page !== "..." && page !== currentPage) {
      console.log("Navigating to page:", page);
      setCurrentPage(page);
    }
  };

  const pages = getPageList();

  if (loadingPrivileges) {
    return <div className="p-3">Loading permissions...</div>;
  }

  if (!hasPermission("access")) {
    console.log(
      "Access denied for role_id:",
      localStorage.getItem("role_id"),
      "on Users page"
    );
    return (
      <div className="p-3">
        <div className="alert alert-danger">
          You don't have permission to access this page.
        </div>
      </div>
    );
  }

  const getUsernameOptions = (userType) => {
    const data = userType === "Doctor" ? doctorData : staffData;

    return [
      <option key="select" value="">
        Select User
      </option>,
      ...data.map((item) => {
        const id = item.staff_id || item.doctor_id;
        const name =
          userType === "Doctor"
            ? item.doctor_name
            : `${item.first_name} ${item.last_name}`;
        return (
          <option key={id} value={id}>
            {id} - {name}
          </option>
        );
      }),
    ];
  };

  const renderUsernameField = (data, handleInputChange, isEditMode = false) => {
    if (data.user_type === "Management") {
      return (
        <input
          type="text"
          className="form-control"
          id="username"
          name="username"
          placeholder="Enter Username"
          value={data.username}
          onChange={handleInputChange}
          required
        />
      );
    } else {
      return (
        <select
          className="form-select"
          id="username"
          name="username"
          value={data.username}
          onChange={handleInputChange}
          required
          disabled={!data.user_type}
        >
          {getUsernameOptions(data.user_type)}
        </select>
      );
    }
  };

  return (
    <div className="p-3">
      {hasPermission("create") && (
        <div className="text-end">
          <button
            className="btn btn-sm text-white"
            style={{ backgroundColor: "#01AEBE" }}
            onClick={openAddModal}
          >
            + Add User
          </button>
        </div>
      )}

      {error && (
        <div className="alert alert-danger alert-dismissible fade show mt-2">
          {error}
          <button
            type="button"
            className="btn-close"
            onClick={() => setError(null)}
          ></button>
        </div>
      )}

      {hasPermission("read") && (
        <div className="card card-body mt-2">
          <div className="bg-white rounded shadow-sm">
            <div className="row mb-3 crm-table-toolbar">
              <div className="col-md-2">
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="fas fa-table"></i>
                  </span>
                  <select
                    className="form-select"
                    value={showEntries}
                    onChange={(e) => {
                      console.log(
                        "Changing items per page to:",
                        e.target.value
                      );
                      setShowEntries(e.target.value);
                      setItemsPerPage(
                        e.target.value === "All"
                          ? filteredData.length || 1
                          : parseInt(e.target.value)
                      );
                      setCurrentPage(1);
                    }}
                  >
                    <option value="10">Show 10</option>
                    <option value="20">Show 20</option>
                    <option value="50">Show 50</option>
                    <option value="100">Show 100</option>
                    <option value="200">Show 200</option>
                    <option value="500">Show 500</option>
                    <option value="1000">Show 1000</option>
                    <option value="All">Show All</option>
                  </select>
                </div>
              </div>
              <div className="col-md-7"></div>
              <div className="col-md-3">
                <div className="d-flex align-items-center">
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control pe-5"
                      placeholder="Search"
                      value={searchTerm}
                      onChange={(e) => {
                        console.log("Search term changed to:", e.target.value);
                        setSearchTerm(e.target.value);
                      }}
                      style={{ width: "250px", paddingRight: "2.5rem" }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {loading && <div className="text-center py-3">Loading...</div>}

            <div className="table-responsive">
              <table className="table table-hover">
                <thead style={{ backgroundColor: "#01AEBE", color: "white" }}>
                  <tr>
                    <th>S.No</th>
                    <th>User ID</th>
                    <th>Username</th>
                    <th>User Type</th>
                    <th>Role</th>
                    <th>Status</th>
                    {(hasPermission("update") || hasPermission("delete")) && (
                      <th>Action</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {currentItems.length > 0 ? (
                    currentItems.map((user, index) => (
                      <tr key={user._id || index} className="align-middle">
                        <td>{indexOfFirstItem + index + 1}</td>
                        <td>{user.user_id}</td>
                        <td>
                          {user.user_type === "Doctor"
                            ? doctorData.find(
                              (doc) => doc.doctor_id === user.username
                            )?.doctor_name || user.username
                            : user.user_type === "Staff"
                              ? staffData.find(
                                (staff) => staff.staff_id === user.username
                              )?.first_name || user.username
                              : user.username}
                        </td>
                        <td>{user.user_type}</td>
                        <td>{user.roles_details[0]?.role_name}</td>
                        <td>
                          <span
                            className={`badge rounded-pill px-3 py-2 fw-semibold d-inline-flex align-items-center ${user.status?.toLowerCase() === "active"
                                ? "bg-success text-white"
                                : "bg-danger text-white"
                              }`}
                          >
                            <FontAwesomeIcon
                              icon={
                                user.status?.toLowerCase() === "active"
                                  ? faCheckCircle
                                  : faTimesCircle
                              }
                              className="me-2"
                            />
                            {user.status?.toLowerCase() === "active"
                              ? "Active"
                              : "Inactive"}
                          </span>
                        </td>

                        {(hasPermission("update") ||
                          hasPermission("delete")) && (
                            <td>
                              {user.user_id !== "AFC-U-001" && (
                                <>
                                  {hasPermission("delete") && (
                                    <button
                                      className="btn btn-sm p-1 border-0"
                                      style={{ backgroundColor: "transparent" }}
                                      onClick={() => openDeleteModal(user._id)}
                                    >
                                      <Trash2 size={16} className="text-danger" />
                                    </button>
                                  )}
                                  {hasPermission("update") && (
                                    <button
                                      className="btn btn-sm p-1 border-0"
                                      style={{ backgroundColor: "transparent" }}
                                      onClick={() => handleEdit(user._id, user)}
                                    >
                                      <Edit size={16} className="text-primary" />
                                    </button>
                                  )}
                                </>
                              )}
                              {user.user_id === "AFC-U-001" &&
                                hasPermission("update") && (
                                  <button
                                    className="btn btn-sm p-1 border-0"
                                    style={{ backgroundColor: "transparent" }}
                                    onClick={() => handleEdit(user._id, user)}
                                  >
                                    <Edit size={16} className="text-primary" />
                                  </button>
                                )}
                            </td>
                          )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={
                          hasPermission("update") || hasPermission("delete")
                            ? 7
                            : 6
                        }
                        className="text-center py-3"
                      >
                        {loading ? "Loading..." : "No users found"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="container">
              <div className="d-flex justify-content-between align-items-center p-3 border-top gap-2">
                <button
                  className="btn btn-outline-secondary d-flex align-items-center gap-2"
                  onClick={() =>
                    currentPage > 1 && setCurrentPage(currentPage - 1)
                  }
                  disabled={currentPage === 1}
                >
                  <i className="fas fa-chevron-left"></i>
                  <span className="d-none d-sm-inline">Previous</span>
                </button>

                <div
                  className="d-flex overflow-auto flex-nowrap gap-2 px-2"
                  style={{ maxWidth: "100%" }}
                >
                  {pages.map((page, index) => (
                    <button
                      key={index}
                      className={`btn btn-sm px-3 flex-shrink-0 ${page === currentPage
                          ? "text-white"
                          : "btn-outline-secondary"
                        }`}
                      style={
                        page === currentPage
                          ? { backgroundColor: "#20c997", border: "none" }
                          : {}
                      }
                      onClick={() => handlePageClick(page)}
                      disabled={page === "..."}
                    >
                      {page}
                    </button>
                  ))}
                </div>

                <button
                  className="btn btn-outline-secondary d-flex align-items-center gap-2"
                  onClick={() =>
                    currentPage < totalPages && setCurrentPage(currentPage + 1)
                  }
                  disabled={currentPage === totalPages}
                >
                  <span className="d-none d-sm-inline">Next</span>
                  <i className="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {hasPermission("create") && (
        <div
          className={`modal fade ${showAddModal ? "show" : ""}`}
          style={{ display: showAddModal ? "block" : "none" }}
          tabIndex="-1"
          aria-labelledby="addUserModalLabel"
          aria-hidden={!showAddModal}
        >
          <div className="modal-dialog modal-md modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h6 className="modal-title text-dark" id="addUserModalLabel">
                  Add User
                </h6>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "10px" }}
                  onClick={closeAddModal}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleAddSubmit}>
                  <div className="row mb-1">
                    <div className="col-md-6">
                      <label htmlFor="user_id" className="form-label fw-bold">
                        User ID
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="user_id"
                        name="user_id"
                        value={addData.user_id}
                        onChange={handleAddInputChange}
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="user_type" className="form-label fw-bold">
                        User Type
                      </label>
                      <select
                        className="form-select"
                        id="user_type"
                        name="user_type"
                        value={addData.user_type}
                        onChange={handleAddInputChange}
                        required
                      >
                        <option value="">Select User Type</option>
                        <option value="Management">Management</option>
                        <option value="Doctor">Doctor</option>
                        <option value="Staff">Staff</option>
                      </select>
                    </div>
                  </div>
                  <div className="row mb-1">
                    <div className="col-md-6">
                      <label htmlFor="username" className="form-label fw-bold">
                        Username
                      </label>
                      {renderUsernameField(addData, handleAddInputChange)}
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="password" className="form-label fw-bold">
                        Password
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        id="password"
                        name="password"
                        placeholder="Enter Password"
                        value={addData.password}
                        onChange={handleAddInputChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="row mb-1">
                    <div className="col-md-6">
                      <label htmlFor="role_id" className="form-label fw-bold">
                        Role
                      </label>
                      <select
                        className="form-select"
                        id="role_id"
                        name="role_id"
                        value={addData.role_id}
                        onChange={handleAddInputChange}
                        required
                      >
                        <option value="">Select Role</option>
                        {rolesData.map((item) => (
                          <option key={item.id} value={item.role_id}>
                            {item.role_id} - {item.role_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="status" className="form-label fw-bold">
                        Status
                      </label>
                      <select
                        className="form-select"
                        id="status"
                        name="status"
                        value={addData.status}
                        onChange={handleAddInputChange}
                        required
                      >
                        <option value="">Select Status</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div className="text-center mt-4">
                    <button
                      type="button"
                      className="btn btn-sm px-3 me-2"
                      style={{ backgroundColor: "#e0e0e0", color: "#333" }}
                      onClick={closeAddModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
 disabled={isSubmitting}
                      className="btn text-white btn-sm px-4"
                      style={{ backgroundColor: "#01AEBE" }}
                    >
                       {isSubmitting ? "Submitting..." : "Submit"}
                    </button>
                    
                        
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {hasPermission("update") && (
        <div
          className={`modal fade ${showEditModal ? "show" : ""}`}
          style={{ display: showEditModal ? "block" : "none" }}
          tabIndex="-1"
          aria-labelledby="editUserModalLabel"
          aria-hidden={!showEditModal}
        >
          <div className="modal-dialog modal-md modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h6 className="modal-title text-dark" id="editUserModalLabel">
                  Edit User
                </h6>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "10px" }}
                  onClick={closeEditModal}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleEditSubmit}>
                  <div className="row mb-1">
                    <div className="col-md-6">
                      <label htmlFor="user_id" className="form-label fw-bold">
                        User ID
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="user_id"
                        name="user_id"
                        value={updateData.user_id}
                        readOnly
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="user_type" className="form-label fw-bold">
                        User Type
                      </label>
                      <select
                        className="form-select"
                        id="user_type"
                        name="user_type"
                        value={updateData.user_type}
                        onChange={handleEditInputChange}
                        required
                      >
                        <option value="">Select User Type</option>
                        <option value="Management">Management</option>
                        <option value="Doctor">Doctor</option>
                        <option value="Staff">Staff</option>
                      </select>
                    </div>
                  </div>
                  <div className="row mb-1">
                    <div className="col-md-6">
                      <label htmlFor="username" className="form-label fw-bold">
                        Username
                      </label>
                      {renderUsernameField(updateData, handleEditInputChange, true)}
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="password" className="form-label fw-bold">
                        Password
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        id="password"
                        name="password"
                        placeholder="Enter Password"
                        value={updateData.password}
                        onChange={handleEditInputChange}
                      />
                    </div>
                  </div>
                  <div className="row mb-1">
                    <div className="col-md-6">
                      <label htmlFor="role_id" className="form-label fw-bold">
                        Role
                      </label>
                      <select
                        className="form-select"
                        id="role_id"
                        name="role_id"
                        value={updateData.role_id}
                        onChange={handleEditInputChange}
                        required
                      >
                        <option value="">Select Role</option>
                        {rolesData.map((item) => (
                          <option key={item.id} value={item.role_id}>
                            {item.role_id} - {item.role_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="status" className="form-label fw-bold">
                        Status
                      </label>
                      <select
                        className="form-select"
                        id="status"
                        name="status"
                        value={updateData.status}
                        onChange={handleEditInputChange}
                        required
                      >
                        <option value="">Select Status</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div className="text-center mt-4">
                    <button
                      type="button"
                      className="btn btn-sm px-3 me-2"
                      style={{ backgroundColor: "#e0e0e0", color: "#333" }}
                      onClick={closeEditModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn text-white btn-sm px-4"
                      style={{ backgroundColor: "#01AEBE" }}
                    >
                      Update
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {hasPermission("delete") && (
        <div
          className={`modal fade ${showDeleteModal ? "show" : ""}`}
          style={{ display: showDeleteModal ? "block" : "none" }}
          tabIndex="-1"
          aria-labelledby="deleteUserModalLabel"
          aria-hidden={!showDeleteModal}
        >
          <div className="modal-dialog modal-sm modal-dialog-centered">
            <div className="modal-content" style={{ borderRadius: "10px" }}>
              <div className="modal-header" style={{ borderBottom: "none" }}>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "10px" }}
                  onClick={closeDeleteModal}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body text-center">
                <div style={{ marginBottom: "15px" }}>
                  <span
                    style={{
                      display: "inline-block",
                      width: "40px",
                      height: "40px",
                      backgroundColor: "#fee2e2",
                      borderRadius: "50%",
                      textAlign: "center",
                      lineHeight: "40px",
                    }}
                  >
                    <i
                      className="fas fa-exclamation-triangle"
                      style={{ color: "#dc2626", fontSize: "20px" }}
                    ></i>
                  </span>
                </div>
                <h5 className="modal-title" id="deleteUserModalLabel">
                  Delete User
                </h5>
                <p style={{ marginTop: "10px" }}>
                  You're going to delete this user. Are you sure?
                </p>
              </div>
              <div
                className="modal-footer"
                style={{ borderTop: "none", justifyContent: "center" }}
              >
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  style={{
                    marginRight: "10px",
                    backgroundColor: "#e0e0e0",
                    color: "#333",
                  }}
                  onClick={closeDeleteModal}
                >
                  No, Keep it
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={confirmDelete}
                >
                  Yes, Delete It!
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {(showAddModal || showEditModal || showDeleteModal) && (
        <div className="modal-backdrop fade show"></div>
      )}
    </div>
  );
}

export default User;
